import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useState, useContext } from 'react';
import { buttonShouldFitContainer } from './breakpoints';
import { WidthContext } from '../../../context';
import Icon from '../icon';
export var AkButton = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.button/loading-button' */
  '@atlaskit/button/loading-button');
});
export function useButton(_ref) {
  var forgeDoc = _ref.forgeDoc,
    dispatch = _ref.dispatch;
  var _forgeDoc$props = forgeDoc.props,
    _forgeDoc$props2 = _forgeDoc$props === void 0 ? {} : _forgeDoc$props,
    _forgeDoc$props2$appe = _forgeDoc$props2.appearance,
    appearance = _forgeDoc$props2$appe === void 0 ? 'default' : _forgeDoc$props2$appe,
    text = _forgeDoc$props2.text,
    disabled = _forgeDoc$props2.disabled,
    onClick = _forgeDoc$props2.onClick,
    icon = _forgeDoc$props2.icon,
    _forgeDoc$props2$icon = _forgeDoc$props2.iconPosition,
    iconPosition = _forgeDoc$props2$icon === void 0 ? 'before' : _forgeDoc$props2$icon;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var handleClick = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setLoading(true);
            _context.prev = 1;
            _context.next = 4;
            return dispatch({
              type: 'event',
              handler: onClick,
              args: [],
              extensionData: {}
            });
          case 4:
            _context.prev = 4;
            setLoading(false);
            return _context.finish(4);
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1,, 4, 7]]);
    }));
    return function handleClick() {
      return _ref2.apply(this, arguments);
    };
  }();
  var iconDom;
  if (icon) {
    iconDom = /*#__PURE__*/React.createElement(Icon, {
      size: "medium",
      glyph: icon
    });
  }
  var iconBefore = iconPosition === 'before' ? iconDom : undefined;
  var iconAfter = iconPosition === 'after' ? iconDom : undefined;
  var width = useContext(WidthContext);
  var shouldFitContainer = buttonShouldFitContainer(width);
  return {
    akButtonProps: {
      shouldFitContainer: shouldFitContainer,
      iconBefore: iconBefore,
      iconAfter: iconAfter,
      isLoading: loading,
      isDisabled: disabled,
      appearance: appearance,
      onClick: handleClick,
      children: text
    }
  };
}
export function Button(props) {
  var _useButton = useButton(props),
    akButtonProps = _useButton.akButtonProps;
  var shouldFitContainer = akButtonProps.shouldFitContainer,
    iconBefore = akButtonProps.iconBefore,
    iconAfter = akButtonProps.iconAfter,
    isLoading = akButtonProps.isLoading,
    isDisabled = akButtonProps.isDisabled,
    appearance = akButtonProps.appearance,
    onClick = akButtonProps.onClick,
    children = akButtonProps.children;
  return /*#__PURE__*/React.createElement(AkButton, {
    shouldFitContainer: shouldFitContainer,
    iconBefore: iconBefore,
    iconAfter: iconAfter,
    isLoading: isLoading,
    isDisabled: isDisabled,
    appearance: appearance,
    onClick: onClick
  }, children);
}
export function useActionButtons(_ref3) {
  var forgeDoc = _ref3.forgeDoc,
    dispatch = _ref3.dispatch;
  var _useState3 = useState(forgeDoc.map(function () {
      return false;
    })),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var width = useContext(WidthContext);
  var shouldFitContainer = buttonShouldFitContainer(width);
  var actionButtons = forgeDoc.map(function (actionButtonForgeDoc, index) {
    var _actionButtonForgeDoc = actionButtonForgeDoc.props,
      _actionButtonForgeDoc2 = _actionButtonForgeDoc === void 0 ? {} : _actionButtonForgeDoc,
      _actionButtonForgeDoc3 = _actionButtonForgeDoc2.appearance,
      appearance = _actionButtonForgeDoc3 === void 0 ? 'subtle' : _actionButtonForgeDoc3,
      text = _actionButtonForgeDoc2.text,
      disabled = _actionButtonForgeDoc2.disabled,
      onClick = _actionButtonForgeDoc2.onClick,
      icon = _actionButtonForgeDoc2.icon,
      _actionButtonForgeDoc4 = _actionButtonForgeDoc2.iconPosition,
      iconPosition = _actionButtonForgeDoc4 === void 0 ? 'before' : _actionButtonForgeDoc4;
    var handleClick = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              setLoading(loading.map(function (l, i) {
                if (i === index) {
                  return true;
                }
                return l;
              }));
              _context2.prev = 1;
              _context2.next = 4;
              return dispatch({
                type: 'event',
                handler: onClick,
                args: [],
                extensionData: {}
              });
            case 4:
              _context2.prev = 4;
              setLoading(loading.map(function (l, i) {
                if (i === index) {
                  return false;
                }
                return l;
              }));
              return _context2.finish(4);
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[1,, 4, 7]]);
      }));
      return function handleClick() {
        return _ref4.apply(this, arguments);
      };
    }();
    var iconDom;
    if (icon) {
      iconDom = /*#__PURE__*/React.createElement(Icon, {
        size: "medium",
        glyph: icon
      });
    }
    var iconBefore = iconPosition === 'before' ? iconDom : undefined;
    var iconAfter = iconPosition === 'after' ? iconDom : undefined;
    return {
      shouldFitContainer: shouldFitContainer,
      iconBefore: iconBefore,
      iconAfter: iconAfter,
      isLoading: loading[index],
      isDisabled: disabled,
      appearance: appearance,
      onClick: handleClick,
      children: text
    };
  });
  return {
    akActionButtonProps: actionButtons
  };
}